export default [
  {
    name: 'DHL',
    alias: 'dhl',
  },
  {
    name: 'FedEx',
    alias: 'fedex',
  },
  {
    name: 'UPS',
    alias: 'ups',
  },
  {
    name: 'Other',
    alias: 'other',
  },
];
